import axios from "axios"
const Login_loading=()=>{
    return {type:"login_loading"}
}
const Login_success=(data)=>{
    return {type:"loading_success",payload:data}
}
const Login_failed=()=>{
    return {type:"loading_failed"}
}
// const login=(data)=>{
//     return (dispatch)=>{
//         dispatch(Login_loading)
//         axios.post("https://reqres.in/api/login",data)
//         .then((res)=>{
//             console.log(res.data)
//             dispatch(Login_success(res.data.token))
//         })
//         .catch((e)=>{
//             console.log(e)
//             dispatch(Login_failed)
//         })
//     }
// }
export {Login_loading,Login_success,Login_failed}